export default __webpack_public_path__ + "static/media/404.0843c1a6.png";